import React, { useEffect, useState } from 'react';
import styles from './ReportCard.module.scss';
import { ReportCardInfo } from '../ReportCardInfo/ReportCardInfo';
import { ReportCardChart } from '../ReportCardChart/ReportCardChart';
import { reportTitle } from '../../../../constants/reportTitle';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { dashboardRequestsFilter } from '../../../../helpers/dashboardRequestsFilter';
import { dashboardRequestsSorter } from '../../../../helpers/dashboardRequestsSorter';
import { dashboardRequestsProcessor } from '../../../../helpers/dashboardRequestsProcessor';

export const ReportCard = ({ name, onlyThisPeriod }) => {
  const [showInCutawayState, setShowInCutawayState] = useState(false);
  const [useTheFactState, setUseTheFactState] = useState(false);
  const [barData, setBarData] = useState([]);
  const [periodCardInfo, setPeriodCardInfo] = useState({
    upTo10DaysCount: '0',
    from10To45DaysCount: '0',
    over45DaysCount: '0',
  });
  const [count, setCount] = useState(0);
  const [totalPlan, setTotalPlan] = useState(0);
  const [totalFact, setTotalFact] = useState(0);
  const [totalClosed, setTotalClosed] = useState(0);
  const [periodInfo, setPeriodInfo] = useState({
    TotalUpTo10DaysPlan: 0,
    TotalUpTo10DaysFact: 0,
    TotalUpTo10DaysClosed: 0,
    TotalFrom10To45DaysPlan: 0,
    TotalFrom10To45DaysFact: 0,
    TotalFrom10To45DaysClosed: 0,
    TotalOver45DaysPlan: 0,
    TotalOver45DaysFact: 0,
    TotalOver45DaysClosed: 0,
  });
  const [factCount, setFactCount] = useState('');
  const [planCount, setPlanCount] = useState('');
  const [closeCount, setCloseCount] = useState('');

  const filteredRequests = useSelector(
    (state) => state.statisticsStore.filteredRequests
  );

  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const createDateRange = params.get('createDate');

  useEffect(() => {
    if (filteredRequests?.length) {
      const items = dashboardRequestsFilter(filteredRequests);
      const newItems = dashboardRequestsSorter(
        items,
        onlyThisPeriod,
        createDateRange
      );
      const requests = [...new Set(newItems?.[name])];

      const {
        barData: BAR_DATA,
        count,
        periodInfo,
        totalPlan,
        totalFact,
        totalClosed,
      } = dashboardRequestsProcessor(requests, createDateRange, name);

      if (name === 'receive' || name === 'annulled') {
        const newCount = newItems?.[name].length || 0;
        setCount(newCount);
      }

      setBarData(BAR_DATA);
      setPeriodInfo(periodInfo);
      setTotalPlan(totalPlan);
      setTotalFact(totalFact);
      setTotalClosed(totalClosed);
    }
  }, [
    filteredRequests,
    filteredRequests.length,
    name,
    onlyThisPeriod,
  ]);

  useEffect(() => {
    if (name === 'receive' || name === 'annulled') return;

    let periodCounts = {
      upTo10DaysCount: periodInfo.TotalUpTo10DaysFact,
      from10To45DaysCount: periodInfo.TotalFrom10To45DaysFact,
      over45DaysCount: periodInfo.TotalOver45DaysFact,
    };

    if (name === 'complete') {
      if (showInCutawayState && useTheFactState) {
        setPlanCount(totalPlan);
        setCloseCount(totalClosed);
        setFactCount('');
        setCount(1);
      } else if (showInCutawayState) {
        setPlanCount(totalPlan);
        setFactCount(totalFact);
        setCloseCount('');
        setCount(1);
      } else if (useTheFactState) {
        setPlanCount('');
        setFactCount('');
        setCloseCount(totalClosed);
        setCount(1);
      } else {
        setFactCount(totalFact);
        setPlanCount('');
        setCloseCount('');
        setCount(1);
      }
    } else {
      if (showInCutawayState && useTheFactState) {
        periodCounts.upTo10DaysCount = `${periodInfo.TotalUpTo10DaysPlan}/${periodInfo.TotalUpTo10DaysClosed}`;
        periodCounts.from10To45DaysCount = `${periodInfo.TotalFrom10To45DaysPlan}/${periodInfo.TotalFrom10To45DaysClosed}`;
        periodCounts.over45DaysCount = `${periodInfo.TotalOver45DaysPlan}/${periodInfo.TotalOver45DaysClosed}`;
      } else if (showInCutawayState) {
        periodCounts.upTo10DaysCount = `${periodInfo.TotalUpTo10DaysPlan}/${periodInfo.TotalUpTo10DaysFact}`;
        periodCounts.from10To45DaysCount = `${periodInfo.TotalFrom10To45DaysPlan}/${periodInfo.TotalFrom10To45DaysFact}`;
        periodCounts.over45DaysCount = `${periodInfo.TotalOver45DaysPlan}/${periodInfo.TotalOver45DaysFact}`;
      } else if (useTheFactState) {
        periodCounts.upTo10DaysCount = periodInfo.TotalUpTo10DaysClosed;
        periodCounts.from10To45DaysCount = periodInfo.TotalFrom10To45DaysClosed;
        periodCounts.over45DaysCount = periodInfo.TotalOver45DaysClosed;
      }
    }

    setPeriodCardInfo(periodCounts);
  }, [
    name,
    periodInfo,
    showInCutawayState,
    totalClosed,
    totalFact,
    totalPlan,
    useTheFactState,
  ]);

  const title = reportTitle[name];

  return (
    <div className={styles.root}>
      <ReportCardInfo
        planCount={planCount}
        factCount={factCount}
        closeCount={closeCount}
        showInCutawayState={showInCutawayState}
        useTheFactState={useTheFactState}
        setShowInCutawayState={setShowInCutawayState}
        setUseTheFactState={setUseTheFactState}
        link={name}
        title={title}
        totalRequests={count}
        periodInfo={periodCardInfo}
      />
      <ReportCardChart
        showInCutawayState={showInCutawayState}
        useTheFactState={useTheFactState}
        cardName={name}
        data={barData}
        count={count}
      />
    </div>
  );
};
